export enum CourseActionTypes {
    LIST_REQUEST = '@@Course/LIST_REQUEST',
    LIST_SUCCESS = '@@Course/LIST_SUCCESS',
    LIST_ERROR = '@@Course/LIST_ERROR',
    LIST_CLEAR = '@@Course/LIST_CLEAR',

    SELECT = '@@Course/SELECT',
    SELECTED = '@@Course/SELECTED',
    CLEAR_SELECTED = '@@Course/CLEAR_SELECTED',
    
    CREATE_REQUEST = '@@Course/CREATE_REQUEST',
    CREATE_SUCCESS = '@@Course/CREATE_SUCCESS',
    CREATE_ERROR = '@@Course/CREATE_ERROR',
    
    // READ_REQUEST = '@@Course/READ_REQUEST',
    // READ_SUCCESS = '@@Course/READ_SUCCESS',
    // READ_ERROR = '@@Course/READ_ERROR',

    UPDATE_REQUEST = '@@Course/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@Course/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@Course/UPDATE_ERROR',
    
    DELETE_REQUEST = '@@Course/DELETE_REQUEST',
    DELETE_SUCCESS = '@@Course/DELETE_SUCCESS',
    DELETE_ERROR = '@@Course/DELETE_ERROR'
}

export interface CourseUIState {
    readonly loading: boolean
    readonly searchParams?: any
    readonly processing: boolean // For CRUD Operation
    readonly processState: number
    readonly selected?: string
    readonly errors?: string []
    readonly isConflict : boolean
    readonly totDoc?: number
}
